export enum FilesRoot {
  ImportQueue = 'import-queue',
  ImportProcessed = 'import-processed',
  ExportQueue = 'export-queue',
  ExportProcessed = 'export-processed',
  ImportProcessing = 'import-processing',
}

export type FilesRoots = Record<FilesRoot, string>;
